import { createFileRoute, Outlet } from '@tanstack/react-router'
import { OperatorProvider } from '../lib/operator-context'
import OperatorSidebar from '../components/operator/OperatorSidebar'
import { LanguageToggle } from '../components/operator/LanguageToggle'

export const Route = createFileRoute('/_auth/operator')({
  component: OperatorLayout,
})

function OperatorLayout() {
  return (
    <OperatorProvider>
      <div className="flex h-screen bg-gray-50">
        <OperatorSidebar />
        <main className="flex-1 overflow-auto">
          <div className="sticky top-0 z-10 flex justify-end px-6 py-2 bg-gray-50/95 backdrop-blur-sm">
            <LanguageToggle />
          </div>
          <Outlet />
        </main>
      </div>
    </OperatorProvider>
  )
}
